import React from 'react'
import {Link} from 'react-router-dom'

export default function ProjectCards({Image,ProjectTitle,GitLink,LiveLink}){
    return(
        <div className="card m-3 col-lg-4 mx-auto col-md-4">
            <div className='card-img-top p-2'>
                <img className="img-fluid img-thumbnail" src={Image} alt="Project"/>
            </div>
            <div className="card-body">
                <p className="lead"><span style={{color: "var(--mainBlue)",fontWeight:"bold"}}>Project Title:</span> { ProjectTitle }</p>
                <div className="d-flex justify-content-between pt-4 border-top border-warning">
                    <a className="btn btn-dark btn-outline-warning" style={{color:"white"}} href={LiveLink}>Live Demo</a>
                    <a className="btn btn-primary btn-outline-success" style={{color:"white"}} href={GitLink}>Github</a>
                </div>
            </div>
        </div>
    )
}